var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cookies", class: { "cookies--open": _vm.openWindow } },
    [
      _c(
        "div",
        {
          staticClass: "cookies__window",
          class: { "cookies__window--open": _vm.openWindow }
        },
        [
          _c("div", { staticClass: "cookies__window__container" }, [
            _c("div", { staticClass: "cookies__window__container__header" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "cookies__window__container__header__title" },
                [_c("h1", [_vm._v(_vm._s(_vm.$t("privacy_settings")))])]
              )
            ]),
            _c("div", { staticClass: "cookies__window__container__content" }, [
              _c(
                "div",
                { staticClass: "cookies__window__container__content__nav" },
                _vm._l(_vm.cookiesList, function(item, index) {
                  return _c("div", { key: index }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "cookies__window__container__content__nav__item",
                        class: {
                          "cookies__window__container__content__nav__item--selected":
                            _vm.infoItem.id === item.id
                        },
                        on: {
                          click: function($event) {
                            return _vm.setItem(item)
                          }
                        }
                      },
                      [
                        _c("h3", [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.title) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ])
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "cookies__window__container__content__info",
                  class: {
                    "cookies__window__container__content__info--fadein":
                      _vm.cloneId
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "cookies__window__container__content__info__header"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "cookies__window__container__content__info__header__title"
                        },
                        [_c("h3", [_vm._v(_vm._s(_vm.infoItem.title))])]
                      ),
                      _vm.infoItem.toggle
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "cookies__window__container__content__info__header__toggle"
                            },
                            [
                              _c("toggle-view", {
                                on: { setResult: _vm.getToggleInfo }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "cookies__window__container__content__info__text"
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.infoItem.text) +
                            "\n            "
                        )
                      ])
                    ]
                  )
                ]
              )
            ]),
            _c(
              "div",
              { staticClass: "cookies__window__container__responsive" },
              [
                _c("dropdown-expanded-view", {
                  attrs: { items: _vm.cookiesList },
                  on: { toggleInfo: _vm.getToggleInfo }
                })
              ],
              1
            ),
            _c("div", { staticClass: "cookies__window__container__buttons" }, [
              _c(
                "div",
                { on: { click: _vm.acceptAllCookies } },
                [
                  _c("button-view", { attrs: { variant: "special full" } }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("cookies_3")) +
                        "\n          "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { on: { click: _vm.saveCookies } },
                [
                  _c("button-view", { attrs: { variant: "primary full" } }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("cookies_4")) +
                        "\n          "
                    )
                  ])
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "cookies__window__container__header__icon" },
      [_c("i", { staticClass: "icon-bliss" })]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e76f0d9a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e76f0d9a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookies/cookies-view.vue
// module id = 389
// module chunks = 10